export default "__VITE_ASSET__e82f39aa__"